import { useEffect, useState } from "react";
import { getWebConfig, saveWebConfig } from "../api/content";
import RichTextEditor from "../components/RichTextEditor";

const emptyForm = {
	quienes_somos_resumen: "",
	quienes_somos_completo: "",
	mision: "",
	vision: "",
	valor: "",
	contacto_email: "",
	contacto_telefono: "",
	contacto_direccion: "",
	social_facebook: "",
	social_instagram: "",
	social_linkedin: "",
};

export default function WebConfigPage() {
	const [form, setForm] = useState(emptyForm);
	const [loading, setLoading] = useState(false);
	const [saving, setSaving] = useState(false);
	const [alert, setAlert] = useState(null);
	const [fieldErrors, setFieldErrors] = useState({});

	useEffect(() => {
		(async () => {
			setLoading(true);
			try {
				const cfg = await getWebConfig();
				if (cfg) {
					setForm({
						...emptyForm,
						...cfg,
					});
				}
			} catch {
				setAlert({
					type: "danger",
					msg: "No se pudo cargar. Intenta de nuevo.",
				});
			} finally {
				setLoading(false);
			}
		})();
	}, []);

	function validateForm() {
		const err = {};
		if (!(form.quienes_somos_resumen ?? "").trim())
			err.quienes_somos_resumen =
				"Quiénes somos (resumen) es obligatorio.";
		if (!(form.quienes_somos_completo ?? "").trim())
			err.quienes_somos_completo =
				"Quiénes somos (completo) es obligatorio.";
		if (!(form.mision ?? "").trim())
			err.mision = "La misión es obligatoria.";
		if (!(form.vision ?? "").trim())
			err.vision = "La visión es obligatoria.";
		if (!(form.valor ?? "").trim()) err.valor = "El valor es obligatorio.";
		if (!(form.contacto_email ?? "").trim())
			err.contacto_email = "El email de contacto es obligatorio.";
		setFieldErrors(err);
		return Object.keys(err).length === 0;
	}

	async function onSubmit(e) {
		e.preventDefault();
		if (!validateForm()) return;
		setSaving(true);
		setAlert(null);
		try {
			await saveWebConfig(form);
			setAlert({
				type: "success",
				msg: "Cambios guardados. Se verán en la página principal.",
			});
		} catch {
			setAlert({
				type: "danger",
				msg: "No se pudo guardar. Revisa los datos e intenta de nuevo.",
			});
		} finally {
			setSaving(false);
		}
	}

	function updateField(field, value) {
		setForm((p) => ({ ...p, [field]: value }));
	}

	return (
		<div className="container-fluid">
			<div className="d-flex align-items-end justify-content-between gap-3">
				<div>
					<h2 className="m-0">Textos y Contacto</h2>
				</div>
			</div>

			{alert && (
				<div className={`alert alert-${alert.type} mt-3`} role="alert">
					<span>{alert.msg}</span>
				</div>
			)}

			<form onSubmit={onSubmit} className="row g-3 mt-2">
				<div className="col-md-6">
					<label className="form-label">
						<span>Quiénes somos (resumen)</span>{" "}
						<span className="text-danger">*</span>
					</label>
					<RichTextEditor
						value={form.quienes_somos_resumen}
						onChange={(value) => {
							updateField("quienes_somos_resumen", value);
							if (fieldErrors.quienes_somos_resumen)
								setFieldErrors((p) => ({
									...p,
									quienes_somos_resumen: undefined,
								}));
						}}
						placeholder="Escribe la versión corta aquí..."
						error={!!fieldErrors.quienes_somos_resumen}
					/>
					{fieldErrors.quienes_somos_resumen && (
						<div className="invalid-feedback">
							{fieldErrors.quienes_somos_resumen}
						</div>
					)}
				</div>

				<div className="col-md-6">
					<label className="form-label">
						<span>Quiénes somos (completo)</span>{" "}
						<span className="text-danger">*</span>
					</label>
					<RichTextEditor
						value={form.quienes_somos_completo}
						onChange={(value) => {
							updateField("quienes_somos_completo", value);
							if (fieldErrors.quienes_somos_completo)
								setFieldErrors((p) => ({
									...p,
									quienes_somos_completo: undefined,
								}));
						}}
						placeholder="Escribe la historia completa aquí..."
						error={!!fieldErrors.quienes_somos_completo}
					/>
					{fieldErrors.quienes_somos_completo && (
						<div className="invalid-feedback">
							{fieldErrors.quienes_somos_completo}
						</div>
					)}
				</div>

				<div className="col-md-4">
					<label className="form-label">
						<span>Misión</span>{" "}
						<span className="text-danger">*</span>
					</label>
					<RichTextEditor
						value={form.mision}
						onChange={(value) => {
							updateField("mision", value);
							if (fieldErrors.mision)
								setFieldErrors((p) => ({
									...p,
									mision: undefined,
								}));
						}}
						placeholder="Escribe aquí la misión de la organización..."
						error={!!fieldErrors.mision}
					/>
					{fieldErrors.mision && (
						<div className="invalid-feedback">
							{fieldErrors.mision}
						</div>
					)}
				</div>

				<div className="col-md-4">
					<label className="form-label">
						<span>Visión</span>{" "}
						<span className="text-danger">*</span>
					</label>
					<RichTextEditor
						value={form.vision}
						onChange={(value) => {
							updateField("vision", value);
							if (fieldErrors.vision)
								setFieldErrors((p) => ({
									...p,
									vision: undefined,
								}));
						}}
						placeholder="Escribe aquí la visión de la organización..."
						error={!!fieldErrors.vision}
					/>
					{fieldErrors.vision && (
						<div className="invalid-feedback">
							{fieldErrors.vision}
						</div>
					)}
				</div>

				<div className="col-md-4">
					<label className="form-label">
						<span>Valores</span>{" "}
						<span className="text-danger">*</span>
					</label>
					<RichTextEditor
						value={form.valor}
						onChange={(value) => {
							updateField("valor", value);
							if (fieldErrors.valor) {
								setFieldErrors((p) => ({
									...p,
									valor: undefined,
								}));
							}
						}}
						placeholder="Escribe aquí los valores de la organización..."
						error={!!fieldErrors.valor}
					/>
					{fieldErrors.valor && (
						<div className="invalid-feedback">
							{fieldErrors.valor}
						</div>
					)}
				</div>

				<div className="col-md-4">
					<label className="form-label">
						<span>Email de contacto</span>{" "}
						<span className="text-danger">*</span>
					</label>
					<input
						type="email"
						className={`form-control ${fieldErrors.contacto_email ? "is-invalid" : ""}`}
						value={form.contacto_email}
						placeholder="Ej: nombre@correo.com" onChange={(e) => {
							updateField("contacto_email", e.target.value);
							if (fieldErrors.contacto_email)
								setFieldErrors((p) => ({
									...p,
									contacto_email: undefined,
								}));
						}}
						aria-invalid={!!fieldErrors.contacto_email}
					/>
					{fieldErrors.contacto_email && (
						<div className="invalid-feedback">
							{fieldErrors.contacto_email}
						</div>
					)}
				</div>
				<div className="col-md-4">
					<label className="form-label">
						<span>Teléfono</span>
					</label>
					<input
						className="form-control"
						placeholder='no colocar el "+56"'
						value={form.contacto_telefono}
						onChange={(e) =>
							updateField("contacto_telefono", e.target.value)
						}
					/>
				</div>
				<div className="col-md-4">
					<label className="form-label">
						<span>Dirección</span>
					</label>
					<input
						className="form-control"
						value={form.contacto_direccion}
						placeholder="Ingresa contacto direccion" onChange={(e) => updateField("contacto_direccion", e.target.value)
						}
					/>
				</div>

				<div className="col-md-4">
					<label className="form-label">
						<span>Facebook</span>
					</label>
					<input
						className="form-control"
						value={form.social_facebook} onChange={(e) => updateField("social_facebook", e.target.value)
						}
						placeholder="https://facebook.com/..."
					/>
				</div>
				<div className="col-md-4">
					<label className="form-label">
						<span>Instagram</span>
					</label>
					<input
						className="form-control"
						value={form.social_instagram} onChange={(e) => updateField("social_instagram", e.target.value)
						}
						placeholder="https://instagram.com/..."
					/>
				</div>
				<div className="col-md-4">
					<label className="form-label">
						<span>LinkedIn</span>
					</label>
					<input
						className="form-control"
						value={form.social_linkedin} onChange={(e) => updateField("social_linkedin", e.target.value)
						}
						placeholder="https://linkedin.com/..."
					/>
				</div>

				<div className="col-12 mt-3">
					<button
						className="admin-btn"
						type="submit"
						disabled={saving || loading}
					>
						<span>
							{saving ? "Guardando..." : "Guardar cambios"}
						</span>
					</button>
				</div>
			</form>
		</div>
	);
}
